import "@fontsource/roboto"
import "./src/styles/foundation/variable.css"
import "./src/styles/foundation/normalize.css"
import "./src/styles/foundation/base.css"
import "./src/styles/foundation/blog-contents-style.css"

export const onRouteUpdate = () => {
  if (typeof document === "undefined") return

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      // fadeIn / imgReveal
      const elements = document.querySelectorAll(
        ".fadeInUp, .fadeInLeft, .fadeInRight, .fadeIn, .imgReveal"
      )

      if (elements.length) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add("on")
                observer.unobserve(entry.target)
              }
            })
          },
          {
            threshold: 0.1,
          }
        )

        elements.forEach((el) => observer.observe(el))
      }

      // ttl1
      const targets = document.querySelectorAll(".ttl1")

      if (targets.length) {
        const ttlObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add("active")
                ttlObserver.unobserve(entry.target)
              }
            })
          },
          {
            rootMargin: "-30% 0px",
          }
        )

        targets.forEach((el) => ttlObserver.observe(el))
      }
    })
  })
}

export const onClientEntry = () => {
  if (typeof document !== "undefined") {
    document.documentElement.classList.add("js")
  }
}